import React from 'react';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import arrowRight from '../../../../images/arrow-right-blue.svg';


const FleetFaq = ({ faqContent }) => (
  <div className="nyc-fleets-faq">
    <div className="nyc-fleets-faq__container">
      <div className="nyc-fleets-faq__container--header">Frequently Asked Questions</div>
      {faqContent.map((panel, index) => (
        <div key={`faq-item${index}`} className="mini-faq__panel mini-faq__panel--nyc">
          <div className="mini-faq__heading collapsed" data-toggle="collapse" href={`#fleetFaq${index + 1}`}>
            <div className="mini-faq__panel--title mini-faq__panel--title--nyc ">{panel.title}</div>
            <FontAwesomeIcon className="mini-faq__arrow" icon={faChevronDown} />
          </div>
          <div id={`fleetFaq${index + 1}`} className="panel-collapse collapse">
            <div className="mini-faq__panel--body mini-faq__panel--body--nyc">
              <p>{panel.text}</p>
              {panel.link ? (
                <p>
                  {' '}
                  {panel.link.text}{' '}
                  <a className="mini-faq__panel--link" href={panel.link.href} style={{'color': '#128DFF'}}>
                    {' '}
                    {panel.link.title}{' '}
                  </a>{' '}
                </p>
              ) : null}
            </div>
          </div>
        </div>
      ))}
      <Link className="section-1__link section-1__link--nyc nyc-fleets-faq__learn-more" to='/nyc/faq'>
        {'Learn More'}
        <span>
          <img className="section-1__link__icon" src={arrowRight} alt="arrow" />
        </span>
      </Link>
    </div>
  </div>
);

export default FleetFaq;



// WEBPACK FOOTER //
// ./src/components/Static/NYCFleets/Shared/FleetFaq.js